import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { ServerCreateComponent } from '../server-create/server-create.component';
import { UserListComponent } from '../user-list/user-list.component';

@Component({
  selector: 'app-server-user-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./server-user-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class ServerUserListComponent extends UserListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.subentity = 'server';
    this.form = ServerCreateComponent;
  }

  getBody() {
    const body = super.getBody();
    const query = ['service_type', '=', this.subentity.toUpperCase()];
    if (body.query) {
      body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }

}
